<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="key">
              <a-input placeholder="请输入" v-model="queryParams.keyFlag"/>
            </a-form-item>
          </a-col>
          <template>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select button-style="solid" v-model="queryParams.consumptionState">
                  <a-select-option :key="1" :value="1">已消费</a-select-option>
                  <a-select-option :key="0" :value="0">未消费</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="时间">
                <a-range-picker value-format="yyyy-MM-dd" @change="rangePicker" />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="5" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <!-- <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <template v-slot:table>
      <div class="page-header-content">
        <!-- <a-card :bordered="false" class="content"> -->

        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="infoId"
          :scroll="{ fixScreen: true, x: 1300 }"
          @selectedRowChange="selectedRowChange"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.RMS_MQ_LOG_LIST, // 表格方案配置唯一值
              }"
        >
          <!-- 更多选择 -->
          <span slot="btn" slot-scope="{ record }">
            <a href="javascript:void(0);" @click="restartMq(record)" :disabled="record.consumptionState === 1">重试</a>
          </span>
          <span slot="status" slot-scope="{record}">
            {{ statusFormat(record) }}
          </span>
          <span slot="copy" slot-scope="{text, record}">
            <a @click="Clone(text, record)">
              <a-icon type="copy" />
            </a>
            {{ text }}
          </span>
        </ls-api-table>
        <!-- 底部分页按钮 -->
        <!-- </a-card> -->
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { copy, list, restart } from '@/api/system/rmsmqlog'
import TagSelectOption from "@/components/TagSelect/TagSelectOption";
import { generateLsTableResData } from '@/utils/util.js';

export default {
  name: 'Rmsmqlog', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { TagSelectOption },
  data () {
    return {
             // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(list, true),
        pageCurrent: true
      },
       // 高级搜索 展开/关闭
      advanced: true,
      // 分页数据(默认第一页):
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      pageSize: 10,
      total: 0,
      // 表格等待
      tableLoading: false,
      // 表格数据
      list: [],
      // 状态数据字典
      statusOptions: [],
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        keyFlag: undefined,
        consumptionState: undefined,
        startDate: undefined,
        endDate: undefined
      },
      columns: [
        {
          title: 'key',
          dataIndex: 'key',
          ellipsis: true,
          // sorter: true,
          sorter: (a, b) => a.key.localeCompare(b.key),
          scopedSlots: { customRender: 'copy' },
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'consumptionState',
          customRender: (text, row, index) => {
            if (text === 1) {
              return '已消费'
            }
            return '未消费'
          },
          sorter: (a, b) => Number(a.consumptionState) - Number(b.consumptionState),
          align: 'center'
        },
        {
          title: '消息',
          dataIndex: 'message',
          ellipsis: true,
          sorter: true,
          scopedSlots: { customRender: 'copy' },
          align: 'center'
        },
        {
          title: 'MQ发送时间',
          dataIndex: 'sendTime',
          sorter: (a, b) => Number(a.sendTime) - Number(b.sendTime),
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'dataCreateTime',
          scopedSlots: { customRender: 'dataCreateTime' },
          align: 'center'
        },
        {
          title: '消费时间',
          dataIndex: 'consumptionTime',
          scopedSlots: { customRender: 'consumptionTime' },
          align: 'center'
        },
        {
          title: '消费日志',
          dataIndex: 'errorInfo',
          ellipsis: true,
          sorter: true,
          scopedSlots: { customRender: 'copy' },
          align: 'center'
        },
        {
          title: '操作',
          width: 140,
          dataIndex: 'action',
          scopedSlots: { customRender: 'btn' }
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      }
    }
  },
  created () {
   // this.getList()
    this.getDicts('sys_common_status').then(response => {
      this.statusOptions = response.data
    })
  },
  mounted () {
    this.onSearch();
  },
  methods: {
        /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
      },
            // 表单搜索
     onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    // 登录状态字典翻译
    statusFormat (row, column) {
      return this.selectDictLabel(this.statusOptions, row.status)
    },
    Clone (text) {
      copy(text).then((res) => {
        // 这里是调用ant的提示框，可以根据自己的需求看写什么
        this.$message.success(res)
      })
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 查询登录日志列表 */
    getList () {
      this.tableLoading = true
      list(this.queryParams).then(response => {
          this.list = response.rows
          this.total = response.total
          this.tableLoading = false
        }
      )
    },
    // 搜索框中的日期选择
    rangePicker (date, dateString) {
      this.queryParams.startDate = dateString[0];
      this.queryParams.endDate = dateString[1];
      this.dateRange = dateString
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParams.pageNum = 1
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.dateRange = []
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        keyFlag: undefined,
        consumptionState: undefined,
        startDate: undefined,
        endDate: undefined
      }
      this.handleQuery()
    },
    restartMq (record) {
      const params = {
        id: record.id
      }
      restart(params).then(response => {
        if (response.code === 200) {
          this.$message.success('重新消费执行成功!')
          this.onSearch();
        } else {
          this.$message.error(response.msg)
        }
      })
    }
  }
}
</script>
